import CompanyChildCategoriesMainPage from './main';
import CompanyChildCategoryEdit from './edit';
import SingleCompanyChildCategory from './singleCategory';
const routes = [
    {
        path: '/*',
        Component: CompanyChildCategoriesMainPage,
        props: {},
    },
    {
        path: '/:id/edit',
        Component: CompanyChildCategoryEdit,
        props: {},
    },
    {
        path: '/:id',
        Component: SingleCompanyChildCategory,
        props: {},
    },
    {
        path: '/new',
        Component: CompanyChildCategoryEdit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
